import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    getCounters,
    getEntirelyAssignedProjectCounter,
    getEntirelyAssignedTasksCounter,
    getSearch,
    getTab,
    selectCustomerEntities,
    selectProjectEntities,
    selectTaskEntities,
    isShowArchivedEntities,
    isSearchOpen
} from '../selectors'
import {changeAssignmentPanelTab, revokeAllTypeAction, revokeEntitiesAction, setIsShowArchiveEntities, setSearchString, setSearchOpen} from '../actions'
import {getFullUserInfo} from '../../../../panels/user/userData/selectors'
import ManagementAssignmentPanelTabContent from '../../hierarchyAssignmentsPanelTab/components/ManagementAssignmentPanelTabContent'
import {openEditor} from '../../createUserManagementAssignmentsEditor/actions'


export default connect(
    state => ({
        userFirstName: getFullUserInfo(state).firstName,
        counters: getCounters(state),

        searchString: getSearch(state),
        searchOpen: isSearchOpen(state),

        entirelyAssignedTasksCounter: getEntirelyAssignedTasksCounter(state),
        entirelyAssignedProjectsCounter: getEntirelyAssignedProjectCounter(state),

        customerEntities: selectCustomerEntities(state),
        projectEntities: selectProjectEntities(state),
        taskEntities: selectTaskEntities(state),
        isShowArchivedEntities: isShowArchivedEntities(state),

        openTab: getTab(state),
    }),
    dispatch => ({
        onSearchChanged: bindActionCreators(setSearchString, dispatch),
        onSearchToggled: bindActionCreators(setSearchOpen, dispatch),

        onEntityRevoked: bindActionCreators(revokeEntitiesAction, dispatch),
        onAllRevoked: bindActionCreators(revokeAllTypeAction, dispatch),

        setIsShowArchiveEntities: bindActionCreators(setIsShowArchiveEntities, dispatch),
        onEditButtonClick: bindActionCreators(openEditor, dispatch),

    })
)(ManagementAssignmentPanelTabContent)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/createManagementAssignmentsPanel/components/TabContent.js